var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc"},[_c('div',{ref:"cmain1",staticClass:"cmain",on:{"mouseover":function($event){_vm.autoTimePaused = true},"mouseout":function($event){_vm.autoTimePaused = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }